export default __webpack_public_path__ + "static/media/arrowDown.60907aee.svg";